import React from 'react';
import { compose } from 'redux';
import { MediaSourceType } from '../../types';
import { setGallectionCover } from '../../actions';
import MediaSelector from '../../MediaSelector';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { useGruser } from '../../_hocs/withGruser';
import { DEVIATION_TYPES_ALLOWED_AS_FOLDER_COVER } from '../../constants';
const enhance = compose(connectMediaStore(null, {
    setGallectionCover
}));
export const GallectionCoverSelector = ({ gallection, setGallectionCover: setGallectionCoverAction, onClose })=>{
    const { currentMediaSource } = useCurrentMediaSource();
    const { gruser } = useGruser();
    return /*#__PURE__*/ React.createElement(MediaSelector, {
        initialMediaSource: currentMediaSource,
        gruser: gruser,
        mediaSourceTypes: [
            currentMediaSource,
            MediaSourceType.STASH
        ],
        allowGifs: false,
        allowedDeviationTypes: DEVIATION_TYPES_ALLOWED_AS_FOLDER_COVER,
        onClose: onClose,
        onSelect: (selectedDeviations)=>{
            setGallectionCoverAction({
                gallection,
                deviation: selectedDeviations[0]
            });
            onClose();
        }
    });
};
GallectionCoverSelector.displayName = 'GallectionCoverSelector';
export default enhance(GallectionCoverSelector);

//# sourceMappingURL=GallectionCoverSelector.js.map